import Color from 'color'

export class BotAccountUtils {

  setupBotAppearanceConfigs(botAccount) {
    //elements
    const header = document.querySelector('#blip-chat-header') as HTMLDivElement
    const background = document.querySelector('#app') as HTMLDivElement

    //colors
    //set to default in case bot's extras is not set
    let primaryColor = '#0096fa' //$color-primary

    if (botAccount.extras['blipchat-components-color']) {
      primaryColor = botAccount.extras['blipchat-components-color']
    }

    //set to default in case bot's extras is not set
    let backgroundColor = '#f5f5f5' //$color-surface-2

    if (botAccount.extras['blipchat-chat-color']) {
      backgroundColor = botAccount.extras['blipchat-chat-color']
    }

    if (header && primaryColor) {
      header.style.backgroundColor = primaryColor

      const unmixedColor = Color(primaryColor).string()
      const mediumLightenColor = Color(primaryColor).mix(Color('white'), 0.86).string()
      const strongLightenColor = Color(primaryColor).mix(Color('white'), 0.96).string()
      const darkenColor = Color(primaryColor).mix(Color('black'), 0.4).string()

      // add dinamic stylesheet to DOM
      const sheet = document.createElement('style')

      sheet.innerHTML = `
        .bubble.right { background-color: ${unmixedColor} !important; border-color: ${mediumLightenColor} !important; } .bubble.right div { color: ${strongLightenColor} !important }
        .select .options li { color: ${strongLightenColor}; background-color: ${unmixedColor}; border-color: ${unmixedColor} }
        .request-location .options li { color: ${strongLightenColor}; background-color: ${unmixedColor}; border-color: ${unmixedColor} }
        .request-location .locationIcon bds-icon[name="localization"] { color: ${strongLightenColor} }
        .blip-card .left .fixed-options li, .blip-card .left a, .blip-card .left .next, .blip-card .left .prev { color: ${unmixedColor} !important }
        .blip-chat-start { background-color: ${unmixedColor} }
        .bubble.right { .audio-player-button { fill: ${strongLightenColor} !important } }
        .bubble.right { .slider { background-color: ${darkenColor} !important } }
        .bubble.right { .progress { background-color: ${strongLightenColor} !important } }
        .bubble.right { .progress { .pin { background-color: ${strongLightenColor} !important } } }
        .bubble.right { .blip-change-playback-rate { color: ${strongLightenColor} !important; border-color: ${mediumLightenColor} !important } }
        .bubble.right { .video-player-controls #Play, #Volume, #FullScreen, #Pause { fill: ${strongLightenColor} !important } }
        .bubble.right { .file-right { .description-wrapper { background: ${primaryColor} !important } } }
      `
      document.body.appendChild(sheet)
    }

    if (background && backgroundColor) {
      background.style.backgroundColor = backgroundColor
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/BotAccount.ts